import { GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { s__ } from '~/locale';
import { REQUEST_STATE, PAINTED_DOOR_FEATURES, getInitialRequestState, recordRequest } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/painted_door_request/utils.js?vue3';
import ExplorePremiumModal from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/super_sidebar/components/explore_premium_modal.vue?vue3';
export default {
    name: 'UserMenuExplorePremium',
    components: {
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        GlIcon,
        ExplorePremiumModal
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        groupId: {
            type: Number,
            required: true
        },
        requested: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'action'
    ],
    i18n: {
        label: s__('ExplorePremium|Explore Premium')
    },
    data () {
        return {
            // Owned here, not by the modal, so reopening the modal keeps the Requested state.
            requestState: getInitialRequestState({
                feature: PAINTED_DOOR_FEATURES.EXPLORE_PREMIUM,
                groupId: this.groupId,
                requested: this.requested
            }),
            showModal: false,
            requestMadeThisOpen: false
        };
    },
    computed: {
        groupIdProperty () {
            return String(this.groupId);
        },
        item () {
            return {
                text: this.$options.i18n.label
            };
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- called by the parent user menu via $refs on its dropdown @shown event
        handleMenuShown () {
            this.trackEvent('view_explore_premium_user_menu_item', {
                label: this.requestState,
                property: this.groupIdProperty
            });
        },
        openModal () {
            this.trackEvent('click_explore_premium_user_menu_item', {
                label: this.requestState,
                property: this.groupIdProperty
            });
            this.requestMadeThisOpen = false;
            this.showModal = true;
            this.$emit('action');
        },
        handleModalChange (visible) {
            this.showModal = visible;
        },
        handleModalHide () {
            if (!this.requestMadeThisOpen) {
                this.trackEvent('dismiss_explore_premium_modal', {
                    label: this.requestState,
                    property: this.groupIdProperty
                });
            }
        },
        handleRequest () {
            if (this.requestState !== REQUEST_STATE.NOT_REQUESTED) return;
            this.requestState = REQUEST_STATE.REQUESTED;
            this.requestMadeThisOpen = true;
            this.trackEvent('click_request_premium_features_explore_premium_modal', {
                property: this.groupIdProperty
            });
            recordRequest({
                feature: PAINTED_DOOR_FEATURES.EXPLORE_PREMIUM,
                groupId: this.groupId
            });
        },
        handleLearnMoreClick () {
            this.trackEvent('click_learn_more_explore_premium_modal', {
                label: this.requestState,
                property: this.groupIdProperty
            });
        }
    }
};
